export default __webpack_public_path__ + "static/veracrypt-0715b410a6ca0699813f5db6351ad5bb.png";